<script>
import { SingleImageElementMixin } from "%/dynamic-components/render-engine/components/production/elements/image-element/single-image-element-mixin";
import BaseImageElement
  from "%/dynamic-components/render-engine/components/production/elements/image-element/BaseImageElement.vue";

export default {
  name: "ImageElement",
  extends: BaseImageElement,
  elementPanelSettings: {
    displayName: "Image",
    elementGroup: "general",
    displayIcon: "image",
    elementType: "element",
  },
  mixins: [SingleImageElementMixin],
};
</script>

<style lang="scss" scoped>
</style>
